import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ReportingPeriod } from '../reporting-period';
import { PurchaseReport } from '@app/feature/dealer/report/purchase-report';

@Injectable({
  providedIn: 'root'
})
export class DidNotPurchaseService {

  constructor(private readonly http: HttpClient) {
  }

  CreateDidNotPurchaseReport(startDate: Date, dealerId?: number) {
    const url = `dealers/${ dealerId ? dealerId : 'mine' }/reports/${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()}/did-not-purchase/`;

    return this.http.post(url, { headers: { 'Content-Type': 'application/json' } }).pipe(
      map(response => response ? ReportingPeriod.fromJSON(response) : null)
    );
  }

}
